import React from 'react';
import {View, ViewStyle} from 'react-native';

import {LoadingBox} from '/component/base/LoadingBox';

import {styles} from './Loading.style';
interface LoadingProps {
  style: {
    sponsoredDate?: ViewStyle;
  };
}
export const Loading: React.FC<LoadingProps> = ({style = {}}) => {
  return (
    <View style={styles.container} testID="loading-container">
      <View>
        <LoadingBox style={styles.avatar} testID="loading-box-avatar" />
      </View>
      <View style={styles.informationContainer}>
        <LoadingBox style={styles.name} testID="loading-box-name" />
        <LoadingBox style={styles.rank} testID="loading-box-rank" />
        <LoadingBox
          style={[styles.sponsoredDate, style?.sponsoredDate]}
          testID="loading-box-sponsored-date"
        />
      </View>
    </View>
  );
};
